export interface YourPension {
    aegon: { fundValue: number, transferType: string, productCode: string[] };
    external: { fundValue: number, transferType: string, productCode?: string[] };
    internal: { fundValue: number, transferType: string, productCode?: string[] };
    reAssure: { fundValue: number, transferType: string, productCode: string[] };
    sunLife: { fundValue: number, transferType: string, productCode: string[] };
    phoenixLife: { fundValue: number, transferType: string, productCode: string[] };
    pensionBee: { fundValue: number, transferType: string, productCode: string[] };
    aon: { fundValue: number, transferType: string, productCode: string[] };
    /*ddp1: { fundValue: number, transferType: string, productCode: string[] };
    ddp2: { fundValue: number, transferType: string, productCode: string[] };
    ddp3: { fundValue: number, transferType: string, productCode: string[] };
    ddp4: { fundValue: number, transferType: string, productCode: string[] }; */
    manualSource: string;
    totalSum: number;
    guarantees: string;
    penalties: string;
    fundProvider: string;
    riskAndStaticQuestion: any[];
    cedingFund: number;
    productCodes:any;
    benefitTypes:any;
    cameFromMicrosite: boolean;
    fundValidateInd: boolean;
}
